import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const assetCardDefaultVariants = {
  "size": "md",
  "variant": "subtle",
  "hasError": false
}
const assetCardCompoundVariants = []

const assetCardSlotNames = [
  [
    "root",
    "AssetCard__root"
  ],
  [
    "title",
    "AssetCard__title"
  ],
  [
    "icon",
    "AssetCard__icon"
  ],
  [
    "media",
    "AssetCard__media"
  ],
  [
    "description",
    "AssetCard__description"
  ],
  [
    "content",
    "AssetCard__content"
  ]
]
const assetCardSlotFns = /* @__PURE__ */ assetCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, assetCardDefaultVariants, getSlotCompoundVariant(assetCardCompoundVariants, slotName))])

const assetCardFn = memo((props = {}) => {
  return Object.fromEntries(assetCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const assetCardVariantKeys = [
  "size",
  "variant",
  "hasError"
]
const getVariantProps = (variants) => ({ ...assetCardDefaultVariants, ...compact(variants) })

export const assetCard = /* @__PURE__ */ Object.assign(assetCardFn, {
  __recipe__: false,
  __name__: 'assetCard',
  raw: (props) => props,
  variantKeys: assetCardVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "variant": [
    "outline",
    "solid",
    "subtle",
    "ghost"
  ],
  "hasError": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, assetCardVariantKeys)
  },
  getVariantProps
})